import {StorageObjectDTO} from '../models/dto/StorageObjectDTO';
import {UploadFileDTO} from '../models/dto/UploadFileDTO';
import {CreateFolderDTO} from '../models/dto/CreateFolderDTO';
import {EditFileDTO} from '../models/dto/EditFileDTO';
import {EditFolderDTO} from '../models/dto/EditFolderDTO';
import {SearchFilterPredefined} from '../models/SearchFilterPredefined';
import {TYPE_ALL} from '../components/ObjectTypePicker/resources/FileTypeResource';
import {StatusType} from '../models/StatusType';

export const getEmptyStorageObjectDTO = (): StorageObjectDTO => {
    return {} as StorageObjectDTO;
};

export const getEmptyCreateFolderDTO = (): CreateFolderDTO => {
    return {} as CreateFolderDTO;
};

export const getEmptyEditFolderDTO = (): EditFolderDTO => {
    return {} as EditFolderDTO;
};

export const getEmptyEditFileDTO = (): EditFileDTO => {
    return {} as EditFileDTO;
};

export const getEmptyUploadFileDTO = (): UploadFileDTO => {
    return {} as UploadFileDTO;
};

export const getCreateFolderDTO = (storageObjectDTO: StorageObjectDTO): CreateFolderDTO => {
    let createFolderDTO = storageObjectDTO as CreateFolderDTO;

    return createFolderDTO;
};

export const getEditFolderDTO = (storageObjectDTO: StorageObjectDTO): EditFolderDTO => {
    let editFolderDTO = storageObjectDTO as EditFolderDTO;

    return editFolderDTO;
};

export const getEditFileDTO = (storageObjectDTO: StorageObjectDTO, thumbnail: File | null): EditFileDTO => {
    let editFileDTO = storageObjectDTO as EditFileDTO;
    editFileDTO.thumbnail = thumbnail;

    return editFileDTO;
};

export const getUploadFileDTO = (storageObjectDTO: StorageObjectDTO, thumbnail: File | null, executeFileUpload: boolean, file: File | null): UploadFileDTO => {
    let uploadFileDTO = storageObjectDTO as UploadFileDTO;
    uploadFileDTO.thumbnail = thumbnail;
    uploadFileDTO.executeFileUpload = executeFileUpload;
    uploadFileDTO.file = file;

    return uploadFileDTO;
};

export const getEmptySearchFilterPredefined = (): SearchFilterPredefined => {
    let searchFilterPredefined = {} as SearchFilterPredefined;
    searchFilterPredefined.searchParam = '';
    searchFilterPredefined.objectType = TYPE_ALL;
    searchFilterPredefined.fileTypes = [];

    return searchFilterPredefined;
};

export const isFileDownloadable: (status: StatusType) => boolean = function (status: StatusType) {
    return status !== StatusType.UNRELEASED && status !== StatusType.INFECTED;
}
